import { Box, Typography } from '@mui/material';
import { COPY } from '../copy';
import { resolveCta } from '../cta';
import { useSurface } from '../layouts/block-surface-context';
import { useLayoutStyles } from '../layouts/layout-context';
import type { BlockRenderProps } from '../layouts/types';
import { hasBlockMedia } from '../media';
import { AccentText } from '../primitives/accent-text';
import { BlockMedia } from '../primitives/block-media';
import { AnchorButton, CtaButton } from '../primitives/cta-button';
import { CheckIcon } from '../primitives/icons';
import { Wrap } from '../primitives/wrap';

export const HeroBlock = ({
  block,
  settings,
  plansBlockId,
  savingsPercent,
  onCta,
  pendingCta,
}: BlockRenderProps) => {
  const s = useLayoutStyles('hero');
  const secondaryVariant = useSurface('dark') === 'dark' ? 'dark' : 'ghost';
  if (block.type !== 'hero') return null;

  const hasMedia = hasBlockMedia(block);
  const cta = resolveCta({ settings, onCta, pendingCta, blockId: block.id });

  return (
    <Box sx={s.section}>
      <Wrap>
        <Box sx={s.grid[hasMedia ? 'split' : 'single']}>
          <div>
            <Box sx={s.eyebrow}>{COPY.heroEyebrow}</Box>
            <Typography component="h1" sx={s.headline}>
              <AccentText text={block.headline} surface="dark" />
            </Typography>
            {block.subtext ? (
              <Typography component="p" sx={s.lede}>
                <AccentText text={block.subtext} surface="dark" />
              </Typography>
            ) : null}
            <Box sx={s.ctaRow}>
              <CtaButton target={cta} variant="brand" withArrow />
              {plansBlockId ? (
                <AnchorButton
                  href={`#${plansBlockId}`}
                  label={COPY.compareMemberships}
                  variant={secondaryVariant}
                />
              ) : null}
            </Box>
            {settings.showPricing && savingsPercent !== null ? (
              <Box sx={s.note}>
                <CheckIcon sx={s.noteIcon} />
                {COPY.savingsNote(savingsPercent)}
              </Box>
            ) : null}
          </div>
          {hasMedia ? (
            <div>
              <BlockMedia block={block} frameSx={s.media} />
            </div>
          ) : null}
        </Box>
      </Wrap>
    </Box>
  );
};
